var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    _vm._b(
      {
        ref: "dialog",
        attrs: {
          width: "600",
          scrollable: "",
          persistent: "",
          eager: ""
        },
        on: {
          keydown: function keydown($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            return _vm.close($event)
          },
          "click:outside": _vm.close
        },
        model: {
          value: _vm.value,
          callback: function callback($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      },
      "v-dialog",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "v-card",
        {
          staticClass: "app-card card-borderless"
        },
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" " + _vm._s(_vm.toolbarText) + " ")]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "pt-2 pb-3"
            },
            [_vm._t("default")],
            2
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end pb-4"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.cancel
                  }
                },
                [_vm._v(_vm._s(_vm.cancelText))]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.confirm
                  }
                },
                [_vm._v(_vm._s(_vm.confirmText))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }